import ReactGA from "react-ga4";

const takenKnot = () => ReactGA.event('taken_knot')

const addedNote = () => ReactGA.event('added_note')

const bookMarkedKnot = () => ReactGA.event('bookmarked_knot')


export {takenKnot, addedNote, bookMarkedKnot}